import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Header from "./Header";
import { getFormattedDataByName, getFormattedKeyName } from "utils/helpers/functions";
import { makeStyles } from "@material-ui/core/styles";
import { DATA_TO_DISPLAY } from "pages/meter-management/maintenanceReports/variables";
import { getMaintenanceReportsAPI, retrieveDownloadUrlByType } from "utils/api";
import { useParams } from "react-router";
import { defaultNgiErrorMethod, warnMessage } from "components/Common/responses/message";
import { Modal, Spin } from "antd";
import NotFoundContainer from "components/Common/NotFoundContainer";

const useStyles = makeStyles({
  root: {
    display: "flex",
    backgroundColor: "white",
    padding: 20,
    marginTop: 20,
    borderRadius: 20,
  },
  informationContainer: {
    display: "flex",
    width: "50%",
  },
  mapContainer: {
    width: "50%",
  },
  row: {
    width: "100%",
  },
  item: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    fontSize: 13,
    fontWeight: 300,
    marginBottom: 20,
    width: "50%",
  },
  data: {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 20,
    width: "50%",
  },

  filePreview: {
    width: 36,
    height: 36,
    borderRadius: 5,
    marginRight: 16,
    cursor: "pointer",
  },
  imgPreview: {
    width: "100%",
  },
});

const ReportDetails = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [maintenanceReport, setMaintenanceReport] = useState(null);
  const [isLoading, setLoader] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [pictures, setPictures] = useState([]);
  const [preview, setPreview] = useState("");

  useEffect(() => {
    setLoader(true);
    getMaintenanceReportsAPI({
      reportId: id,
    })
      .then(res => {
        setLoader(false);
        const {
          result: { items },
        } = res?.data;
        if (items.length === 0) {
          warnMessage("Report not found");
          setIsNotFound(true);
        }
        setMaintenanceReport(items[0] || null);
      })
      .catch(err => {
        setLoader(false);
        setMaintenanceReport(null);
        defaultNgiErrorMethod(err);
      });
  }, [id]);

  useEffect(async () => {
    if (maintenanceReport?.testingData?.pictures) {
      setLoader(true);
      const urls = await Promise.all(
        maintenanceReport?.testingData?.pictures.map(item =>
          retrieveDownloadUrlByType("picture", item).then(({ data: { result } }) => result.url)
        )
      );
      setLoader(false);
      setPictures(urls);
    }
  }, [maintenanceReport?.testingData?.pictures]);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <NotFoundContainer isNotFound={isNotFound}>
            <Spin spinning={isLoading}>
              <>
                <Header data={maintenanceReport} />
                <div className={classes.root}>
                  <div className={classes.informationContainer}>
                    {maintenanceReport && (
                      <div className={classes.row}>
                        {DATA_TO_DISPLAY.map(key => {
                          if (key === "testingData") {
                            return (
                              <div key={`${key}-testingData`} className={classes.item}>
                                <div className={classes.title}>{getFormattedKeyName(key)} :</div>
                                <div className={classes.data}>
                                  {pictures.length
                                    ? pictures.map(item => (
                                        <img
                                          key={item}
                                          alt="preview"
                                          onClick={() => setPreview(item)}
                                          className={classes.filePreview}
                                          src={item}
                                        />
                                      ))
                                    : "-"}
                                </div>
                              </div>
                            );
                          }
                          return (
                            <div key={`${key}-item`} className={classes.item}>
                              <div className={classes.title}>{getFormattedKeyName(key)} :</div>
                              <div className={classes.data}>
                                {getFormattedDataByName(key, maintenanceReport[key] || "-")}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                  <div className={classes.mapContainer}></div>
                </div>
              </>
            </Spin>
          </NotFoundContainer>
          <Modal title="Photo preview" open={Boolean(preview)} onCancel={() => setPreview("")} footer={null}>
            <img className={classes.imgPreview} src={preview} alt="img preview" />
          </Modal>
        </Container>
      </div>
    </>
  );
};

export default ReportDetails;
